import { addCommas, digitsEnToFa } from '@persian-tools/persian-tools';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AuthService, PaymentStatusPreSubmit, UserService } from 'src/app/core';
import { PaymentTransportationMethod } from 'src/app/shared';
import { ResponsiveService } from 'src/app/feature';

@Component({
  selector: 'shopping-cart-payment-status',
  templateUrl: './payment-status.component.html',
  styleUrls: ['./payment-status.component.sass'],
})
export class PaymentStatusWebComponent implements OnInit {
  @Output('submit') submitEvent: EventEmitter<any> = new EventEmitter();
  @Input('status') status!: PaymentStatusPreSubmit;

  @Input() transportMethod!: PaymentTransportationMethod;
  @Input() disabled!: boolean;

  @Input() submitTitle!: string;

  public isUserLoggedIn: boolean = false;
  public isUserActivated: boolean = false;

  public paymentAcceptance!: BehaviorSubject<{
    isUserLoggedIn: boolean;
    isUserActivated: boolean;
  }>;

  // ---------------------------------------------------------->

  public get isMobile(): Observable<boolean> {
    return this.responsiveService.isMobile$;
  }

  public get isNotMobile(): Observable<boolean> {
    return this.responsiveService.isMobile$.pipe(map((val) => !val));
  }

  // Constructors --------------------------------------------->

  constructor(
    private responsiveService: ResponsiveService,
    private userService: UserService,
    private authService: AuthService
  ) {}

  async ngOnInit(): Promise<void> {
    this.isUserLoggedIn = await this.userService.isLoggedIn();
    this.isUserActivated = await this.userService.isUserActivated();

    this.paymentAcceptance = new BehaviorSubject({
      isUserActivated: this.isUserActivated,
      isUserLoggedIn: this.isUserLoggedIn,
    });

    this.authService.userProfile.subscribe(() => this.updateUserAcceptanceStatus());
    // this.userService.status$.subscribe(() => this.updateUserAcceptanceStatus());
  }

  // Public methods ------------------------------------------->

  public getSelectedItemsCount() {
    const count = this.status.selectedCount;
    return this.toPersian(count.toString());
  }

  public getPrice(): string {
    let price = parseInt(this.status.price.toString());

    if (this.transportMethod) {
      price = price + parseInt(this.transportMethod.valueAdded);
    }

    return this.toPersian(this.withComma(price.toString()));
  }

  public submit() {
    this.submitEvent.emit();
  }

  public openPhoneConfirmDialog() {
    this.authService.openUserActivationBoxDelay(1);
  }

  // Private methods ------------------------------------------>

  protected async updateUserAcceptanceStatus(): Promise<void> {
    this.isUserLoggedIn = await this.userService.isLoggedIn();
    this.isUserActivated = await this.userService.isUserActivated();

    this.paymentAcceptance.next({
      isUserActivated: this.isUserActivated,
      isUserLoggedIn: this.isUserLoggedIn,
    });
  }

  protected toPersian(str: string): string {
    return digitsEnToFa(str);
  }
  protected withComma(str: string): string {
    return addCommas(str);
  }
}
